import _ from 'lodash'
import { getElemName, option } from '../lib/common'

export const getPropInfo = (property, elem, elementUID, widgetElements) => {
  let propInfo = {
    default: '',
  }
  switch (property) {
    case 'filesLimit':
      propInfo.type = 'number'
      propInfo.label = 'Max files'
      propInfo.default = '12'
      break
    case 'tabOrder':
      propInfo.type = 'number'
      propInfo.label = 'Tab Order'
      break
    case 'acceptLabel':
      propInfo.type = 'text'
      propInfo.label = ''
      break
    case 'allowAccept':
      propInfo.type = 'checkbox'
      propInfo.label = 'File Types'
      propInfo.default = false
      break
    case 'singleSelection':
      propInfo.type = 'checkbox'
      propInfo.label = 'Single selection'
      propInfo.default = false
      break
    case 'useCurrentDate':
      switch (elem.getIn(['props', 'control'])) {
        case 'date':
          propInfo.label = 'Use current date'
          propInfo.type = 'checkbox'
          break
        case 'time':
          propInfo.label = 'Use current time'
          propInfo.type = 'checkbox'
          break
        case 'datetime':
          propInfo.label = 'Use current date and time'
          propInfo.type = 'checkbox'
          break
      }
      break
    case 'dependentParentPickList':
      propInfo.label = 'Select parent dropdown'
      propInfo.type = 'list'
      propInfo.options = []
      widgetElements.map((field, uid) => {
        if (uid != elementUID) {
          if (field.getIn(['props', 'control'], 'text') == 'select') {
            propInfo.options.push(option(getElemName(field.toJS()), uid))
          }
        }
      })
      break
    case 'isRandomize':
      propInfo.type = 'checkbox'
      propInfo.label = 'Shuffle Options'
      break
    case 'isDistinct':
      propInfo.type = 'checkbox'
      propInfo.label = 'Distinct options'
      break
    case 'isAllowClear':
      propInfo.type = 'checkbox'
      propInfo.label = 'Allow clear'
      break
    case 'isLoadCustomPickList':
      propInfo.type = 'checkbox'
      propInfo.label = 'Load Custom List'
      break
    case 'multipleSelection':
      propInfo.type = 'checkbox'
      propInfo.label = 'Multiple selection'
      break
    case 'dependentPickList':
      propInfo.type = 'checkbox'
      propInfo.label = 'Dependent picklist'
      break
    case 'sfAsDefault':
      propInfo.type = 'checkbox'
      propInfo.label = 'Salesforce Default'
      break
    case 'displayValueLabel':
      propInfo.type = 'checkbox'
      propInfo.label = 'Display Value Label'
      break
    case 'marks':
      propInfo.type = 'checkbox'
      propInfo.label = 'Show Ticks'
      break
    case 'track':
      propInfo.type = 'checkbox'
      propInfo.label = 'Active Line'
      break
    case 'step':
      propInfo.type = 'checkbox'
      propInfo.label = 'Step'
      break
    case 'hideAsterisk':
      propInfo.type = 'checkbox'
      propInfo.label = 'Hide Asterisk'
      break
    case 'isDisabled':
      propInfo.type = 'checkbox'
      propInfo.label = 'Disable'
      break
    case 'mandatory':
      propInfo.type = 'checkbox'
      propInfo.label = 'Mandatory'
      break
    case 'passwordMode':
      propInfo.type = 'checkbox'
      propInfo.label = 'Password mode'
      break
    case 'autoFocus':
      propInfo.type = 'checkbox'
      propInfo.label = 'Auto Focus'
      break
    case 'readOnly':
      propInfo.type = 'checkbox'
      propInfo.label = 'Read Only'
      break
    case 'disallowPaste':
      propInfo.type = 'checkbox'
      propInfo.label = 'Disallow paste'
      break
    case 'disableAutoSuggest':
      propInfo.type = 'checkbox'
      propInfo.label = 'Disable auto suggest'
      break
    case 'hideValidIndicator':
      propInfo.type = 'checkbox'
      propInfo.label = 'Hide valid text'
      propInfo.default = true
      break
    case 'isShowLabel':
      propInfo.type = 'checkbox'
      propInfo.default = true
      break
    case 'hideErrorIndicator':
      propInfo.type = 'checkbox'
      propInfo.label = 'Hide error text'
      propInfo.default = true
      break
    case 'maximumLength':
      propInfo.type = 'numeric'
      propInfo.label = 'Maximum Length'
      break
    case 'fieldMask':
      propInfo.type = 'text'
      propInfo.label = 'Field mask'
      break
    case 'numType':
      propInfo.type = 'list'
      propInfo.label = 'Type'
      propInfo.options = [option('Integer', 'integer'), option('Decimal', 'decimal')]
      propInfo.default = 'integer'
      break
    case 'minVal':
      propInfo.type = 'numeric'
      propInfo.label = 'Min'
      break
    case 'maxVal':
      propInfo.type = 'numeric'
      propInfo.label = 'Max'
      break
    case 'decimalDigits':
      propInfo.type = 'numeric'
      propInfo.label = 'Decimal digits'
      break
    case 'dateFormat':
      propInfo.type = 'list'
      propInfo.label = 'Format'
      propInfo.options = [option('MM/DD/YYYY', 'MM/DD/YYYY'), option('DD/MM/YYYY', 'DD/MM/YYYY')]
      propInfo.default = 'MM/DD/YYYY'
      break
    case 'timeFormat':
      propInfo.type = 'list'
      propInfo.label = 'Time Format'
      propInfo.options = [option('12', '12'), option('24', '24')]
      propInfo.default = '12'
      break
    case 'orderBox':
      propInfo.type = 'checkbox'
      propInfo.label = 'Order box'
      propInfo.default = true
      break
  }
  return propInfo
}

export const getListOfProperties = (elem, layoutMode, isAll) => {
  let properties = ['isDisabled', 'mandatory', 'variant', 'isShowLabel', 'label']
  if (isAll) {
    properties = properties.concat(['maximumLength', 'visibleRows'])
  }
  let fieldType = elem.get('type')
  if (fieldType == 'FormField') {
    fieldType = elem.getIn(['props', 'control'], 'text')
  }
  if (['Rating', 'StarRating', 'TextCounter'].indexOf(fieldType) > -1) {
    properties = ['isDisabled', 'mandatory']
  } else if (fieldType === 'TextReview') {
    properties = ['tabOrder']
  } else {
    switch (fieldType) {
      case 'TextCounter':
      case 'ExternalLookup':
        properties = properties.concat([
          // 'maximumLength',
          //  'fieldMask',
          'autoFocus',
          'readOnly',
        ])
        break
      case 'text':
        properties = properties.concat([
          // 'maximumLength',
          //  'fieldMask',
          'autoFocus',
          'readOnly',
          'disallowPaste',
          'disableAutoSuggest',
          'placeholder',
          'passwordMode',
        ])
        break
      case 'phone':
        properties = properties.concat(['autoFocus', 'readOnly'])
        break
      case 'currency':
        properties = properties.concat(['autoFocus', 'readOnly'])
        break
      case 'number':
        properties = properties.concat([
          'autoFocus',
          // 'numType',
          'placeholder',
        ])
        // if (elem.getIn(['props', layoutMode, 'numType'], '') == 'decimal') {
        //     properties.push('decimalDigits');
        // }
        properties = properties.concat([
          // 'minVal', 'maxVal',
          'autoFocus',
          'readOnly',
          'disallowPaste',
          // 'disableAutoSuggest'
        ])
        break
      case 'textarea':
        properties = properties.concat([
          // 'maximumLength',
          'autoFocus',
          'readOnly',
          'disallowPaste',
          'disableAutoSuggest',
          'placeholder',
        ])
        break
      case 'email':
        properties = properties.concat(['autoFocus', 'readOnly', 'disallowPaste', 'disableAutoSuggest', 'placeholder'])
        break
      case 'url':
        properties = properties.concat(['autoFocus', 'readOnly', 'disallowPaste', 'disableAutoSuggest', 'placeholder'])
        break
      case 'date':
        properties = properties.concat([
          'autoFocus',
          'readOnly',
          // 'useCurrentDate',
          // 'dateFormat',
          'placeholder',
        ])
        break
      case 'time':
        properties = properties.concat([
          'autoFocus',
          'readOnly',
          // 'useCurrentDate',
          // 'timeFormat',
          'placeholder',
        ])
        break
      case 'datetime':
        properties = properties.concat([
          'autoFocus',
          'readOnly',
          // 'useCurrentDate',
          // 'dateFormat',
          // 'timeFormat',
          'placeholder',
        ])
        break
      case 'daterange':
        properties = properties.concat([
          'autoFocus',
          'placeholder',
          'readOnly',
          // 'useCurrentDate',
          // 'dateFormat',
          // 'timeFormat',
          // 'placeholder'
        ])
        break
      case 'slider':
        properties = properties.concat([
          // 'minVal', 'maxVal',
          //  'step',
          'displayValueLabel',
          'marks',
          'track',
        ])
        properties = _.filter(properties, (key) => key !== 'mandatory')
        break
      case 'Range':
        properties = _.filter(properties, (v) => v !== 'mandatory')
        break
      case 'checkbox':
        properties = properties.concat(['autoFocus', 'sfAsDefault', 'singleSelection', 'isDistinct'])
        break
      case 'lookup':
        properties = properties.concat(['autoFocus', 'placeholder', 'multipleSelection'])
        break
      case 'switch':
        properties = properties.concat(['autoFocus'])
        properties = _.filter(properties, (key) => key !== 'mandatory')
        break
      case 'radio':
        //'isLoadCustomPickList'
        properties = properties.concat(['autoFocus', 'isRandomize', 'items', 'isDistinct'])
        break
      case 'multiSelect':
      case 'select':
        properties = properties.concat(['autoFocus', 'isRandomize', 'readOnly', 'sfAsDefault', 'dependentPickList'])
        if (elem.getIn(['props', layoutMode, 'dependentPickList'], false)) {
          properties.push('dependentParentPickList')
        }
        //'isRandomize',
        properties = properties.concat(['items', 'isDistinct'])
        break
      case 'buttongroup':
        properties = properties.concat([
          'autoFocus',
          'isRandomize',
          'sfAsDefault',
          'orientation',
          'items',
          'isDistinct',
        ])
        break
      case 'fileupload':
        properties = properties.concat([
          'autoFocus',
          'isImageCompression',
          // 'filesLimit',
          // 'allowAccept'
        ])
        // if (elem.getIn(['props', layoutMode, 'allowAccept'], false)) {
        //     properties.push('acceptLabel');
        // }
        break
    }
  }
  if (elem.get('type') === 'Range') {
    properties = properties.concat(['hideAsterisk', 'hideValidIndicator', 'tabOrder'])
  } else if (elem.get('type') === 'Ranking') {
    return _.filter(properties, (prop) => prop !== 'mandatory').concat(['orderBox', 'tabOrder'])
  } else if (elem.get('type') === 'ExternalLookup') {
    properties = properties.concat(['hideAsterisk', 'tabOrder'])
  } else if (elem.get('type') !== 'TextReview') {
    properties = properties.concat(['hideAsterisk', 'hideValidIndicator', 'hideErrorIndicator', 'tabOrder'])
  }

  if (properties.includes('hideAsterisk') && !properties.includes('mandatory')) {
    // Validation hook - 'hideAsterisk' should not exist without 'mandatory'
    properties = _.filter(properties, (v) => v !== 'hideAsterisk')
  }

  return _.uniq(properties)
}
